import {routerHandler} from "../../../resources/utils/router";
import {UserViewInfoComponent} from "./user-view-info/user-view-info.component";
import {UserViewPurchasesComponent} from "./user-view-purchases/user-view-purchases.component";
import {UserViewProjectsComponent} from "./user-view-projects/user-view-projects.component";
import {UserViewStoreCollectionsComponent} from "./user-view-store-collections/user-view-store-collections.component";
import {UserViewActionStatesComponent} from "./user-view-action-states/user-view-action-states.component";
import {UserViewCoinFlowComponent} from "./user-view-coin-flow/user-view-coin-flow.component";
import {Routes} from "@angular/router";

export const UserViewRoutesData = {
  'redirect': routerHandler.redirect('user'),
  'info': routerHandler.info('user', {component: UserViewInfoComponent}),
  'purchases': routerHandler.purchases('user', {component: UserViewPurchasesComponent}),
  'projects': routerHandler.projects('user', {component: UserViewProjectsComponent}),
  'storeCollections': routerHandler.storeCollections('user', {component: UserViewStoreCollectionsComponent}),
  'actions': routerHandler.actions('user', {component: UserViewActionStatesComponent}),
  'coinFlow': routerHandler.coinFlow('user', {component: UserViewCoinFlowComponent}),
};

export const UserViewRoutes: Routes = Object.values(UserViewRoutesData);
